import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './IconLabelButton.styled';
import {
  IconLabelButtonSizes,
  IconLabelButtonTypes,
} from './IconLabelButtonUtil';

const IconLabelButton = (props) => {
  return (
    <Styled.NewButton
      as={props.as}
      onClick={props.onClick}
      disabled={props.disabled}
      $type={props.type}
      $size={props.size}
      className={props.className}
      href={props.href}
      aria-label={props['aria-label']}
    >
      {props.icon && <Styled.IconWrapper>{props.icon}</Styled.IconWrapper>}
      {props.children}
    </Styled.NewButton>
  );
};

IconLabelButton.defaultProps = {
  type: IconLabelButtonTypes.CLEAR,
  size: IconLabelButtonSizes.MEDIUM,
};

IconLabelButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  type: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  dialogState: PropTypes.object,
  as: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  tooltip: PropTypes.string,
};

export {
  IconLabelButtonSizes,
  IconLabelButtonTypes,
} from './IconLabelButtonUtil';
export default IconLabelButton;
